export default {
  en: {
    'pages.processing-page.in_progress': 'Processing',
    'pages.processing-page.initializing': 'Initializing',
    'pages.processing-page.queued': 'Queued for processing',
    'pages.processing-page.about-to-start': 'We are busy preparing your data please wait...',
    'pages.processing-page.finalising': 'Finalising processing...',
  },
};
